import { CartAddEvent, CartUpdateEvent } from '@theme/events';
const getCartData = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  
  const getFreeGiftData = async (str) => {
    if (!str) return;
    const handle = str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  
    try {
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      if (res.ok) {
        return data;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  
  const addToCart = async (e) => {
    const self = e.target;
    const parent = self.closest('.free-gift');
    if (!parent) return;
  
    const referId = parent.dataset.referId;
    const referType = parent.dataset.type;
    const referProductId = parent.dataset.referProductId;
    if (!referId || !referType) return;
  
    const variantEl = parent.querySelector('[name="variants"]');
    const variantId = variantEl.value ?? null;
    if (!variantId) return;
  
    self.classList.add('btn--loading');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: +variantId,
            quantity: 1,
            properties: {
              '_free-gift-with-purchase': true,
              '_free-gift-refer-id': referId,
              '_free-gift-refer-type': referType,
              '_free-gift-refer-product-id': referProductId
            }
          }]
        })
      });
      // const data = await response.json();
      if(response.ok) {
        document.dispatchEvent(
          new CartAddEvent({}, variantId, {
            source: 'free-gift-component',
            itemCount: 1,
          })
        );
        parent.closest('free-gift-with-purchase').remove();
      } else {
        const errorData = await response.json().catch(() => null);
        throw new Error('Failed to add to cart: ' + (errorData?.description || response.statusText));
      }
    } catch (error) {
      console.log(error)
    } finally {
      self.classList.remove('btn--loading');
    }
  };
  
  const removeFreeGift = async (data) => {
    const { key } = data;
    if (!key) return;
  
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [key]: 0
          }
        })
      });
      if (res.ok) {
        document.dispatchEvent(
          new CartUpdateEvent({}, key, {
            source: 'free-gift-component',
            itemCount: 1,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  const init = async (e) => {
    const cartData = await getCartData();
    if (!cartData) return;
  
    const { items } = cartData;
    const freeGifts = items.filter((item) => item.properties && item.properties['_free-gift-with-purchase']);
  
    if (Array.isArray(freeGifts) && freeGifts.length) {
      freeGifts.forEach((freeGift) => {
        const referId = freeGift.properties['_free-gift-refer-id'];
        const referType = freeGift.properties['_free-gift-refer-type'];
  
        if (referType && referType === 'bundle') {
          const referBundle = items.some(item => item.properties['_bundleUniqueID'] === referId);
          if (!referBundle) removeFreeGift(freeGift);
        }
  
        if (referType && referType === 'product') {
          const referProduct = items.find((item) => item.key === referId);
          if (!referProduct) removeFreeGift(freeGift);
        }
      });
    }
  }
  
  class FreeGiftWithPurchase extends HTMLElement {
    constructor() {
      super();
      this.#initialize();
    }
  
    async #initialize() {
      const type = this.dataset.type;
      const tag = this.dataset.tag;
      const referId = this.dataset.referId;
      const referProductId = this.dataset.referProductId;
      if (!type || !referId || !tag || !referProductId) return;
  
      const cartData = await getCartData();
      if (!cartData) return;
  
      const { items } = cartData;
      const freeGift = items.find(item => item.properties && item.properties['_free-gift-with-purchase'] && item.properties['_free-gift-refer-id'] === referId);
      // Exit since free gift is already in cart
      if (freeGift) {
        return;
      }
  
      const handle = tag.replace('_fgwp_', '');
      const data = await getFreeGiftData(handle);
      this.#render({ data, referId, type, referProductId });
    }
  
    #render({ data, referId, type, referProductId }) {
      if (!data || !type || !referId || !referProductId) return;
  
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const content = document.createElement('div');
  
      const variants = () => {
        const { variants } = data;
        let markup = '';
  
        if (variants.length === 1) {
          const [ onlyVariant ] = variants;
          markup = `
            <input type="hidden" name="variants" value="${onlyVariant.id}">
          `;
        } else {
          markup = `
            <select name="variants">${ variants.map(variant => `<option value="${variant.id}"${variant.available ? "" : " disabled"}>${variant.title}</option>`).join('') }</select>
          `;
        }
        return markup;
      }
  
      // Summary label
      summary.innerText = 'Add your free gift';
      summary.classList.add('cart-items__title');
  
      // Contents
      content.classList.add('gwp-contents');
      content.innerHTML = `
        <div class="free-gift" data-type="${type}" data-refer-id="${referId}" data-refer-product-id="${referProductId}">
          <a href="${data.url}" class="media media-fit-cover">
            <img src="${data.featured_image}" alt="${data.title}" loading="lazy" style="aspect-ratio: 1;" />
          </a>
          <div>
            <a href="${data.url}" class="cart-items__title">${data.title}</a>
            ${variants()}
            <button type="button" name="add-free-gift" class="button">Add</button>
          </div>
        </div>
      `;
  
      details.append(summary, content);
      details.open = true; // Sets detail element to be open initially
      this.append(details);
  
      const button = this.querySelector('button[name="add-free-gift"]');
      if (button) {
        button.addEventListener('click', addToCart);
      }
    }
  }
  customElements.define('free-gift-with-purchase', FreeGiftWithPurchase);
  
  
  ['DOMContentLoaded', 'cart:update'].forEach((event) => {
    document.addEventListener(event, init);
  });
  
  const confirmation = document.querySelector("#backdrop");

  const getCheckoutButton = () => document.querySelector('.cart__checkout-button');
  const hasPendingFreeGift = () => document.querySelector('free-gift-with-purchase > *') !== null;

  document.addEventListener('submit', btnCheckoutClick);
  document.addEventListener('click', handleConfirmationClick);

  function handleConfirmationClick(event) {
    if (!(event.target instanceof Element)) return;

    const cancelButton = event.target.closest('.button__cancel');
    if (cancelButton) {
      confirmation?.classList.remove('active');
      return;
    }

    const continueButton = event.target.closest('.button__continue');
    if (!continueButton) return;

    event.preventDefault();

    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({
        note: "I don't want free gift"
      }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function() {
      confirmation?.classList.remove('active');
      getCheckoutButton()?.classList.add('btn--loading')
      window.location.href = "/checkout";
    });
  }
  
  function btnCheckoutClick(event) {
    const form = event.target;
    const submitter = event.submitter;

    if (!(form instanceof HTMLFormElement) || !(submitter instanceof HTMLElement)) return;
    if (submitter.name !== 'checkout' && !submitter.matches('.cart__checkout-button')) return;

    event.preventDefault();
  
    if (hasPendingFreeGift()) {
      confirmation?.classList.add('active');
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          note: ""
        }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function() {
        confirmation?.classList.remove('active');
        submitter.classList.add('btn--loading')
        window.location.href = "/checkout";
      });
    }
  }
